import React from 'react'
import { Table } from 'antd'
import { formatDifferences } from './utils'

const ExcelAnswerTable = ({ answer, studentMode }) => {
    const excelAnswerTableColumns = [
        {
            title: 'Name',
            dataIndex: 'name',
            key: 'name',
        },
        {
            title: 'Value',
            key: 'value',
            dataIndex: 'value',
            render: value => <div dangerouslySetInnerHTML={{ __html: value }} />,
        },
    ]

    let excelAnswerTableData

    if (studentMode) {
        excelAnswerTableData = [
            {
                key: 'yourAnswer',
                name: 'Your answer',
                value: answer?.original_value,
            },
            {
                key: 'correctAnswer',
                name: 'Correct answer',
                value: answer?.correct_value,
            },
            ...(answer?.is_text
                ? []
                : [
                      {
                          key: 'yourFormula',
                          name: 'Your formula',
                          value: answer?.original_formula,
                      },
                  ]),
        ]
    } else {
        excelAnswerTableData = [
            {
                key: 'originalValue',
                name: 'Original value',
                value: answer?.original_value,
            },
            {
                key: 'expandedValue',
                name: 'Expanded value',
                value: answer?.expanded_value,
            },
            ...(answer?.is_text
                ? []
                : [
                      {
                          key: 'originalFormula',
                          name: 'Original formula',
                          value: answer?.original_formula,
                      },
                      {
                          key: 'expandedFormula',
                          name: 'Expanded formula',
                          value: formatDifferences(answer?.expanded_formula, answer?.formula_differences),
                      },
                      {
                          key: 'referenceFormula',
                          name: 'Reference formula',
                          value: formatDifferences(answer?.reference_formula, answer?.reference_differences),
                      },
                  ]),
        ]
    }

    return (
        <Table
            className='mb-16'
            columns={excelAnswerTableColumns}
            dataSource={excelAnswerTableData}
            pagination={false}
            showHeader={false}
            size='small'
            bordered
            title={() => <b>{answer.address}</b>}
        />
    )
}

export default ExcelAnswerTable
